import { useMemo } from 'react';
import { useRMSelector } from 'redux/hooks';
import { useAllWellNavigationDetails, useSelectedDropImageParameters } from 'redux/hooks/experiment';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';

const useCurrentRegionIds = (): number[] => {
  const wellNavigationDetails = useAllWellNavigationDetails();
  const selectedDropImageParameters = useSelectedDropImageParameters();
  const {dropNumber, regionName} = selectedDropImageParameters || {}
  const exp = useRMSelector(selectExp);
  const regionIds = useMemo(() => {
    const foundRegionId = [];
    wellNavigationDetails?.forEach((wd) => {
      exp?.regions?.forEach((region) => {
        const drop = region.drops.find(
          (d) =>
            d.plateId === wd?.plateID &&
            d.wellNumber === wd?.wellNum &&
            d.dropNumber === dropNumber &&
            d.regionName === regionName,
        );

        if (drop) {
          foundRegionId.push(drop.regionId);
          return;
        }
      });
    });
    return foundRegionId;
  }, [wellNavigationDetails, dropNumber, regionName, exp?.regions]);
  return regionIds;
};

export default useCurrentRegionIds;
